import {RootState} from '../../store';
import {Invoice} from './types';

export const selectionSelector = (state: RootState): Record<string, Invoice> =>
    state['invoices'].selection as Record<string, Invoice>;
